import { logger } from "@/utils/logger";
import { FileContent, LeaseForgeUser, UserState } from "@/types";
import { Module } from "vuex";
import {
  SaveUser,
  SaveParty,
  buildSelectedUser,
  getTeamFromUserId,
  getTeamMembersByManagerCode,
  userList,
  getManagerByTeam,
  UpdateTeamMembers,
  savePartyRoleNetwork,
  getPerson,
  resetPasswordFromAdmin,
  addUserAuthorities,
  getUserLogs,
  getPartyRoleNetwork,
  updatePartyRoleNetwork,
  createUserGroup, updateUserGroup, createUserAuthority
} from "@/store/services/user/userService";
import {getUser, signUp} from "@/store/services/auth";
import { sendUserAccountCreationEmail } from "@/store/services/user/userAccountEmailService";
import Notify from 'quasar/src/plugins/Notify.js';;
import store from "@/store";
import { deepClone,notExpiredOption,credintialsOption, notLockedOption, statusOption, UON, updateUserGroups } from "@/utils";
import {
  ensureUserGroupsFromApi,
  hasValidUserGroups,
} from "@/utils/userGroups";
import i18n from "@/i18n";
import {
  getNetwork,
  getNetworkNode,
  getNetworkNodeAll,
  saveFile,
} from "@/store/services/offerService";
import router from "@/router";
import { get } from "sortablejs";
import { getBase64 } from "@/commons/gathering-process-order";

function errorMessage(err: any) {
    Notify.create({
        timeout: 3000,
        actions: [{ icon: 'close', color: 'white' }],
        message: err.message || err.error || err,
        color: 'negative'
    });
}

function handlingError(err: any) {
    if (err.response) {
        if (err.response.status === 401) {
            errorMessage(`Error! Unauthorized.`);
        }
        else if (err.response.status === 400 && err.response.data && err.response.data.message && err.response.data.message.returnMessage && err.response.data.message.returnMessage === 'PasswordAlreadyUsedException') {
            errorMessage(i18n.global.t('main.connect.changePasswordMessageUnchanged'));
        }
        else {
            logger.error(err.message)
            // errorMessage(i18n.global.t('main.connect.'+(err.response.data.message.additionalInfo[0].message.replaceAll(' ', '_').replaceAll(',', '').replaceAll('.', ''))));
        }
    } else {
        logger.error(err.message)
        // errorMessage(`Error! ${err.message}`);
    }
}

const userModule: Module<UserState, any> = {
  namespaced: true,
  state: {
    mode: "add",
    selectedUserDetails: {},
    team: {},
    teamMembers: [],
    userParty: {},
    managers: [],
    networkDetails: {
      network: {},
      networkNode: {},
      networkNodePicklist: [],
    },
    temporaryPassword: "",
    userLogs: [],
    selectedAvatar: null,
    // avatarConfig: null,
    avatarFileId: null,
    isAvatarEdited: false,
  },

  getters: {
    getUserselectedInit() {
      return {
        objectType: "odm.user.leaseforgeuser",
        systemUid: "odm-user",
        businessData: null,
        daaq: "/",
        username: "",
        applicationName: "TWDDemo",
        firstName: "",
        lastName: "",
        email: "",
        associatedParty: {
          objectType: "odm.party.party.person",
          systemUid: "odm-party",
          resourceUid: "",
        },
        personalAuthorities: [],
        userGroups: [

        ],
        personalDAAQs: [],
        accountNotExpired: notExpiredOption[0].value,
        accountNotLocked: notLockedOption[0].value ,
        credentialsNotExpired: credintialsOption[0].value,
        enabled: statusOption[0].value,
        defaultLanguage: null,
        preferredLanguages: [],
        avatarFileId: null,
      };
    },
    getPartyInit() {
      return {
        objectType: "odm.party.party.person",
        systemUid: "odm-party",
        businessData: null,
        daaq: "/",
        reference: null,
        taxID: null,
        taxGeographicZone: null,
        classifications: [],
        roles: [
          {
            objectType: "odm.party.partyrole",
            role: {
              objectType: "odm.party.role",
              resourceUid: "EMPLOYEE",
            },
            status: {
              objectType: "odm.party.rolestatus",
              resourceUid: "ACTIVATED",
            },
            daaq: "/",
          },
        ],
        contacts: [],
        addresses: [],
        statusHistory: [],
        accounts: [],
        correspondents: [],
        financialExposures: [],
        generatedDocuments: [],
        currentStatus: null,
        title: null,
        firstName: "",
        middleName: null,
        familyName: "",
        birthDate: "1970-01-01",
        birthplace: null,
        nbOfChildren: null,
        gender: null,
        nbOfDependent: null,
        maritalStatuses: [],
        citizenships: [],
        ids: [],
        revenues: [],
        jobs: [],
        legalEntity: null,
      };
    },
    getTeamInit() {
      return {}
    },
    getTeamMembersInit() {
      return []
    },
    getnetworkDetailsInit() {
      return {
        networkDetails: {
          network: {},
          networkNode: {},
          networkNodePicklist: [],
        }
      }
    },
    getSelectedAvatar(state) {
      return state.selectedAvatar ?? [];
    },
    getIsAvatarEdited(state) {
      return state.isAvatarEdited;
    },
    getAvatarFileId(state) {
      return state.avatarFileId;
    },
  },

  actions: {

    cleanState({commit}) {
      commit('cleanState')
    },

    /**
     * Searches for user based on the given filter.
     * @param {object} context - The context object.
     * @param {object} payload - The payload object containing the filter and a callback function.
     * @return {void}
     */
    searchUser(context, payload) {
      // Gets the callback function from the payload.
      const { filter,offset , limit, callback } = payload;
      // Calls the `userList()` function to fetch the list of user.
      userList(filter,offset,limit)
        .then((response) => {
          // Passes the response to the callback function.
          callback(response);
        })
        .catch((err) => {
          // Logs the error to the console.
          logger.error(err);
        });
    },
    setMode({ commit }, payload) {
      commit("setMode", payload);
    },
    resetUser({ commit }, payload) {
      commit("resetUser", payload);
    },

    updatePassword({ commit }, payload) {
      commit("updatePassword", payload);
    },
    updatePasswordHandler({ commit }, payload) {
      return resetPasswordFromAdmin(payload.username, payload.newPassword)
        .then(() => {
          store.state.userModule.selectedUserDetails.temporaryPassword = true;
        })
        .catch((e: any) => {
          handlingError(e);
          throw e;
        });
    },
    updateTeam({ commit }, payload) {
      commit("updateTeam", payload);
    },
    executeSelectUser({ commit }, payload) {
      const { mode, user: listUser, callback } = payload;
      const userId = listUser?.id ?? listUser?.resourceUid;
      if (!userId) {
        logger.error("executeSelectUser: missing user id", payload);
        callback?.();
        return;
      }

      getUser(userId)
        .then(async (user) => {
          if (user?.data) {

            getTeamFromUserId(user.data.resourceUid)
              .then((res) => {

                commit("setTeam", res[0]);
                if (res && res.length > 0) {
                  getTeamMembersByManagerCode(
                    store.state.userModule.team.config.manager_code
                  )
                    .then((response) => {
                      commit("setTeamMembers", response);
                    })
                    .catch((e: any) => logger.error(e));
                }
              })
              .catch((e: any) => logger.error(e));

            const userSelected = await buildSelectedUser(user.data, payload.user);
            store.state.userModule.selectedUserDetails.resourceUid = userSelected.resourceUid
            if (mode && mode === "add") {
              store.state.userModule.selectedUserDetails.userGroups.forEach((item: any) => delete item.resourceUid)
            }
            if (!mode) {
              commit("saveUser", userSelected);
            }




            getPerson(user.data.associatedParty.resourceUid).then((person) => {
              if (!person.birthDate) {
                person.birthDate = "1970-01-01"
              }
              store.state.userModule.userParty = person
              if (mode && mode === "add") {
                store.state.userModule.userParty.roles = [
                  {
                    objectType: "odm.party.partyrole",
                    role: {
                      objectType: "odm.party.role",
                      resourceUid: "EMPLOYEE",
                    },
                    status: {
                      objectType: "odm.party.rolestatus",
                      resourceUid: "ACTIVATED",
                    },
                    daaq: "/",
                  },
                ],



                  store.dispatch("userModule/createUser", {
                    notifyType: "Addsuccess",
                    callback: () => { }
                  });
              }

              getUserLogs(userSelected.username).then((res) => {
                commit("setUserLogs", res);
              }).catch((e: any) => logger.error(e));
            }).catch((e: any) => logger.error(e));


            callback();
          }
        })
        .catch((err) => {
          Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: `Error searching Good \n ${err}`,
            color: "negative",
          });
        });
    },
    getManagerByTeam({ commit }, payload) {
      getManagerByTeam(payload)
        .then((res: any) => {
          commit("setManager", res[0]);
        })
        .catch((e: any) => logger.error(e));
    },
    resetUserParty({ commit }, payload) {
      commit("resetUserParty", payload);
    },
    setManagers({ commit }, payload) {
      const managers = payload.map((el: { id: string; manager_code: string }) => {
        return {
          team_id: el.id,
          manager_code: el.manager_code,
        };
      });

      commit("setManagers", managers);
    },
    network({ commit }, payload) {
      const { filter, callback } = payload;
      getNetwork(filter)
        .then((res) => {
          // logger.debug('setNetwork', res)
          callback(res);
        })
        .catch((e) => logger.error(e));
    },
    networknode({ commit }, payload) {
      const { filter, callback } = payload;
      getNetworkNode(filter)
        .then((res) => {
          callback(res);
        })
        .catch((e) => logger.error(e));
    },

    async saveUser({ commit }, payload) {
      const { user, callback } = payload;
      const userDetails = deepClone(user);
      let createUserPayload = {
        notifyType: "",
        callback: callback
      }
      if (!userDetails.resourceUid) {

       
        createUserPayload.notifyType = "Addsuccess";

        const userPayload = {
          username: userDetails.username,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          email: userDetails.email,
          // password: store.state.userModule.temporaryPassword,
          password: "ERTXMp@123",
          applicationName: "TWDDemo",
          phoneNumber: userDetails.phoneNumber,
          daaqList: "/"
        }
        store.state.isLoading = true
        updateUserGroups(store.state.userModule.selectedUserDetails.userGroups)
        const groupsForCreate =
          store.state.userModule.selectedUserDetails.userGroups ?? [];
        if (!hasValidUserGroups(groupsForCreate)) {
          store.state.isLoading = false;
          Notify.create({
            timeout: 10000,
            actions: [{ icon: "close", color: "white" }],
            message: i18n.global.t("main.messageRequiredField"),
            color: "negative",
          });
          return;
        }
        try {
          const res = await signUp(userPayload, true);
          await store.dispatch("userModule/updatePasswordHandler", {
            username: userDetails.username,
            newPassword: store.state.userModule.temporaryPassword,
          });

          for (const group of groupsForCreate) {
            await createUserGroup(group, res.userId);
          }

          const userDefaultDaaq = {
            objectType: "odm.user.userdaaq",
            systemUid: "odm-user",
            businessData: null,
            daaqComponent: {
              objectType: "odm.user.daaq",
              systemUid: "odm-user",
              resourceUid: "DEFAULT_DAAQ",
            },
          };

          await createUserAuthority(userDefaultDaaq, res.userId);

          await store.dispatch("userModule/executeSelectUser", {
            mode: "add",
            user: {
              id: res.userId,
            },
            callback: () => {},
          });

          try {
            await sendUserAccountCreationEmail({
              email: userDetails.email,
              username: userDetails.username,
              password: store.state.userModule.temporaryPassword,
            });
          } catch (emailErr) {
            logger.warn("Account creation email failed", emailErr);
            Notify.create({
              timeout: 10000,
              actions: [{ icon: "close", color: "white" }],
              message: i18n.global.t("user.creationEmailFailed"),
              color: "warning",
            });
          }

          setTimeout(() => {
            commit("setNewCreatedUser", true);
          }, 2000);
          Notify.create({
            timeout: 10000,
            actions: [{ icon: "close", color: "white" }],
            message: i18n.global.t("user.dialog." + createUserPayload.notifyType),
            color: "positive",
          });
        } catch (err: any) {
          logger.debug(err);
          Notify.create({
            timeout: 10000,
            actions: [{ icon: "close", color: "white" }],
            message: err?.response?.data?.message?.returnMessage || err?.message || String(err),
            color: "negative",
          });
        } finally {
          store.state.isLoading = false;
        }
      } else {
        createUserPayload.notifyType = "Editsuccess";
        store.state.isLoading = true;
        try {
          await ensureUserGroupsFromApi(userDetails.resourceUid);
          if (
            !hasValidUserGroups(
              store.state.userModule.selectedUserDetails.userGroups
            )
          ) {
            Notify.create({
              timeout: 10000,
              actions: [{ icon: "close", color: "white" }],
              message: i18n.global.t("main.messageRequiredField"),
              color: "negative",
            });
            return;
          }
          updateUserGroups(store.state.userModule.selectedUserDetails.userGroups);
          const groupsToSync =
            store.state.userModule.selectedUserDetails.userGroups ?? [];
          for (const group of groupsToSync) {
            if (group.resourceUid && group.resourceUid !== "") {
              await updateUserGroup(group);
            } else {
              await createUserGroup(group, userDetails.resourceUid);
            }
          }
          await store.dispatch("userModule/createUser", {
            notifyType: createUserPayload.notifyType,
            callback: () => {
              store.dispatch("releaseLockState").then(() => {
                commit("setNewCreatedUser", true);
              });
              if (callback) {
                callback();
              }
            },
          });
        } catch (err) {
          logger.warn(err);
          logger.debug(err)
          Notify.create({
            timeout: 10000,
            actions: [{ icon: "close", color: "white" }],
            message: i18n.global.t("main.messageRequiredField"),
            color: "negative",
          });
        } finally {
          store.state.isLoading = false;
        }
      }
    },

    async createUser({ commit }, payload) {
      const { notifyType, callback } = payload;
      store.state.isLoading = true;
      try {
        const partyRes = await SaveParty(store.state.userModule.userParty);
        commit("saveUserParty", partyRes);

        store.state.userModule.selectedUserDetails.associatedParty.resourceUid =
          partyRes.resourceUid;

        const networkNode =
          store.state.userModule.networkDetails.networkNode?.config?.id;
        const rolePayload = {
          body: {
            objectType: "odm.party.partyrolenetwork",
            systemUid: "odm-party",
            businessData: null,
            daaq: "/",
            partyRole: {
              objectType: "odm.party.partyrole",
              systemUid: "odm-party",
              resourceUid: partyRes.roles[0].resourceUid,
            },
          },
          networkNode: networkNode,
        };

        if (networkNode) {
          const allPartyRoleRes = await getPartyRoleNetwork(rolePayload);
          const listPartyRoleRes = allPartyRoleRes.data.filter(
            (s: any) =>
              s.partyRole.resourceUid === partyRes.roles[0].resourceUid
          );
          if (listPartyRoleRes.length === 0) {
            await savePartyRoleNetwork(rolePayload);
          } else if (listPartyRoleRes.length === 1) {
            await updatePartyRoleNetwork(listPartyRoleRes[0]);
          }
        }

        const user = await SaveUser(
          store.state.userModule.selectedUserDetails
        );
        await UpdateTeamMembers(user);

        if (store.state.userModule.mode === "add") {
          addUserAuthorities(user.resourceUid).catch((e) => logger.warn(e));
        }

        Notify.create({
          timeout: 10000,
          actions: [{ icon: "close", color: "white" }],
          message: i18n.global.t("user.dialog." + notifyType),
          color: "positive",
        });

        if (callback) {
          callback();
        }
      } catch (err: any) {
        logger.warn(err);
        throw err;
      } finally {
        store.state.isLoading = false;
      }
    },

    initUserModule({ commit }) {
      commit("initUserModule");
    },
    setSelectedAvatar({ commit }, payload) {
       
      commit("setSelectedAvatar", payload);
    },
    setIsAvatarEdited({ commit }, payload) {
      commit("setIsAvatarEdited", payload);
    },
    setAvatarFileId({ commit }, payload) {
      commit("setAvatarFileId", payload);
    },

  },
  mutations: {
    setUserLogs(state, payload) {
      state.userLogs = payload
    },
    setMode(state, payload) {
      state.mode = payload;
    },
    setNewCreatedUser(state, payload) {
      state.newCreatedUser = payload
    },
    resetUser(state, payload) {
      if (state.selectedUserDetails) state.selectedUserDetails = payload;
    },
    saveUser(state, payload) {
      state.selectedUserDetails = payload;
    },
    setTeam(state, payload) {
      state.team = payload;
    },
    setManager(state, payload) {
      state.manager = payload;
    },
    setTeamMembers(state, payload) {
      state.teamMembers = payload;
    },
    setSelectedAvatar(state, payload) {
      state.selectedAvatar = payload;
    },
    setIsAvatarEdited(state, payload) {
          state.isAvatarEdited = payload;
        },
    setAvatarFileId(state, payload) {
      state.avatarFileId = payload;
    },
    resetUserParty(state, payload) {
      if (state.userParty) state.userParty = payload;
    },
    UpdateUserParty(state, payload) {
      state.userParty.firstName = payload.firstName;
      state.userParty.familyName = payload.lastName;
    },
    updatePassword(state, payload) {
      state.temporaryPassword = payload;
    },
    updateTeam(state, payload) {
      state.team = payload;
    },
    setManagers(state, payload) {
      state.managers = payload;
    },
    setNetwork(state, payload) {
      state.networkDetails.network = payload;
    },
    saveUserParty(state, payload) {
      if (state.userParty) state.userParty = payload;
    },
    UpdateassociatedParty(state, payload) {
      if (state.selectedUserDetails) {
        state.selectedUserDetails.associatedParty = payload;
      }
    },
    initUserModule(state) {
      const userPartyGetter = store.getters["userModule/getPartyInit"];
      store.dispatch("userModule/resetUserParty", userPartyGetter);
      const userGetter = store.getters["userModule/getUserselectedInit"]
      store.dispatch("userModule/resetUser", userGetter);
      state.team = {};
      state.teamMembers = [];
      state.networkDetails = {
        network: {},
        networkNode: {},
        networkNodePicklist: [],
      };
      state.selectedAvatar = null;
      state.avatarFileId = null;
      state.isAvatarEdited = false;
      state.temporaryPassword = "";
      state.newCreatedUser = false;
    }
  },
};
export default userModule;
